




























































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

import * as api from '@/scripts/services/api';
import * as blockui from '@/helpers/block-ui';
import { hasPageAccess } from '@/scripts/services/authorization';
import Tabs from '@/components/wrappers/TabView/Tabs/Tabs.vue';
import Tab from '@/components/wrappers/TabView/Tab/Tab.vue';

/**
 * Personel profili. Rolden bagimsiz erisilir: route'a bilincli olarak authItem konmadi, boylece
 * guvenlik agacinda bir kayit gerekmeden herkes kendi profiline girebiliyor.
 *
 * Baskasinin profili de ayni ekranda goruntulenir (?userId=) ve TAMAMEN salt okunurdur.
 * Kendi profilinde duzenlenebilen tek sey telefon numarasi; o da oturumdaki kimlige bagli bir
 * uctan gecer (User/UpdateOwnPhone), yani ekranin baskasinin verisine dokunma imkani yok.
 * Izinler dahil geri kalan her sey yalnizca gosterilir.
 *
 * userId verilmezse login'de saklanan kimlik kullanilir.
 */
@Component<UserProfile>({
  components: {
    tabs: Tabs,
    tab: Tab,
  },
})
export default class UserProfile extends Vue {
  @Prop() userId?: string;

  userInfo: any = {};
  jobDescription = '';
  responsibilities: any[] = [];
  trainings: any[] = [];
  shifts: any[] = [];
  workOrders: any[] = [];
  excuses: any[] = [];

  isPhoneSaving = false;

  get profileUserId(): number {
    const fromRoute = Number(this.userId);
    if (Number.isInteger(fromRoute) && fromRoute > 0) {
      return fromRoute;
    }
    return Number(localStorage.getItem('userId'));
  }

  get isOwnProfile(): boolean {
    return this.profileUserId === Number(localStorage.getItem('userId'));
  }

  // Yetkiye tabi sayfalara link basmadan once sorulur; bkz. canOpenWorkOrderDetail kullanimi.
  get canOpenWorkOrderDetail(): boolean {
    return hasPageAccess('my_work_order_page');
  }

  /**
   * Egitim satirlari, durumu hesaplanmis halde. Durum satir basina bir kez turetiliyor;
   * sablon hem metni hem rengi ayni nesneden okuyor.
   */
  get trainingRows(): any[] {
    return this.trainings.map((item) => ({ ...item, status: this.trainingStatus(item) }));
  }

  get shiftRangeText(): string {
    return `${this.formatDate(this.shiftRangeStart)} - ${this.formatDate(this.shiftRangeEnd)}`;
  }

  // Vardiya icin icinde bulunulan ay: profilde "vardiya bilgisi" bir plan ozeti, gecmisin
  // tamami degil. Ekranin omru boyunca sabit oldugu icin alan, getter degil.
  //
  // moment ORNEGI degil ISO metin tutuluyor: sinif alanlari vue-class-component tarafindan
  // reaktif data'ya cevriliyor ve Vue duz nesne gibi gordugu moment ornegini ic alanlarina
  // kadar gezerdi. Ihtiyac duyulan iki bicim de bu metinden uretiliyor.
  private shiftRangeStart = moment().startOf('month').format('YYYY-MM-DD');
  private shiftRangeEnd = moment().endOf('month').format('YYYY-MM-DD');

  async mounted() {
    await this.loadProfile();
  }

  // Personel listesinden ayni ekranda baska bir profile gecilebilmesi icin.
  @Watch('userId')
  async onUserIdChanged() {
    await this.loadProfile();
  }

  async loadProfile() {
    const userId = this.profileUserId;
    if (!userId) {
      return;
    }

    blockui.pageBlock(this);
    try {
      // Yalnizca gorev tanimi + sorumluluklar RoleId'ye, yani kimlik bilgisine bagli. Geri kalan
      // dortlu userId ile calisiyor ve o zaten elimizde; hepsi ayni anda baslatiliyor, boylece
      // kritik yol "kimlik + rol" zinciri kadar oluyor, sirayla toplanan iki tur degil.
      await Promise.all([
        api.getUserInfo(userId).then((response: any) => {
          this.userInfo = response.body || {};
          return this.loadRoleDefinition(this.userInfo.RoleId);
        }),
        this.loadTrainings(userId),
        this.loadShifts(userId),
        this.loadTodaysWorkOrders(userId),
        this.loadExcuses(userId),
      ]);
    } finally {
      blockui.unBlockPage();
    }
  }

  private async loadRoleDefinition(roleId?: number) {
    this.jobDescription = '';
    this.responsibilities = [];
    if (!roleId) {
      return;
    }

    const [roleResponse, responsibilityResponse] = await Promise.all([
      api.getUserRole(roleId),
      api.getRoleResponsibilities({ roleId }),
    ]);

    const rawJobDescription = roleResponse.body ? roleResponse.body.JobDescription : null;
    this.jobDescription = this.decodeJobDescription(rawJobDescription);
    this.responsibilities = (responsibilityResponse.body && responsibilityResponse.body.Data) || [];
  }

  private async loadTrainings(userId: number) {
    const response = await api.getUserTrainingStatus({ userId });
    const rows = (response.body && response.body.Data) || [];

    // Ne rolun gerektirdigi ne de kullanicinin aldigi bir egitimse gosterilecek bir sey yok.
    this.trainings = rows.filter((row: any) => this.isTrainingRequired(row) || row.IssueDate);
  }

  private async loadShifts(userId: number) {
    const response = await api.GetByDateRange({
      startDate: this.shiftRangeStart,
      endDate: this.shiftRangeEnd,
      userId,
    });
    this.shifts = (response.body && response.body.Data) || [];
  }

  private async loadTodaysWorkOrders(userId: number) {
    const response = await api.searchAssignedWorkOrder({
      fromDate: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      userId,
    });
    this.workOrders = (response.body && response.body.Data) || [];
  }

  private async loadExcuses(userId: number) {
    // GetByUserId ResultMessage sarmalayicisi kullanmiyor, listeyi dogrudan donduruyor.
    const response = await api.getUserExcuseList({ userId });
    this.excuses = response.body || [];
  }

  /**
   * Gorev tanimi ayarlarda encodeURIComponent'li kaydediliyor (UserRoleModal/UserRoleDialog).
   * Eski kayitlar kodlanmamis olabildigi icin cozme denemesi hataya dusurmemeli.
   */
  private decodeJobDescription(raw?: string | null): string {
    if (!raw) {
      return '';
    }
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }

  //#region Telefon
  async saveOwnPhone() {
    this.isPhoneSaving = true;
    try {
      const response = await api.updateOwnPhone({ Phone: this.userInfo.Phone });
      if (response.body && response.body.IsSuccess) {
        toastr.success(this.translate('save_successfully'));
      } else {
        toastr.error((response.body && response.body.Message) || this.translate('undefined_error'));
      }
    } finally {
      this.isPhoneSaving = false;
    }
  }
  //#endregion

  raciLabels(item: any): string[] {
    const labels: string[] = [];
    if (item.IsResponsible) labels.push(this.translate('responsible'));
    if (item.IsAccountable) labels.push(this.translate('accountable'));
    if (item.IsConsulted) labels.push(this.translate('consulted'));
    if (item.IsInformed) labels.push(this.translate('informed'));
    if (item.IsObserver) labels.push(this.translate('observer'));
    return labels;
  }

  /** Training_Role.Duration null ise rol bu egitimi gerektirmiyor (0 = bir kez, N = N ayda bir). */
  private isTrainingRequired(item: any): boolean {
    return item.Duration !== null && item.Duration !== undefined;
  }

  /**
   * Egitim durumu SP'nin IsValid alanindan DEGIL, Duration + IssueDate + ExpireDate uzerinden
   * turetiliyor. Sebep: sp_Training'in IsValid'i "onumuzdeki daysToCheck gun icinde de sorun
   * cikmayacak mi" demek, yani bir uyari penceresini gecerlilikle karistiriyor.
   *
   * Duration = 0 "bir kez alinir, suresi dolmaz" anlaminda; N ise N ay gecerli.
   * Metin ve renk tek yerden dondurulur ki kurallar ikiye ayrilmasin.
   */
  private trainingStatus(item: any): { text: string; badgeClass: string } {
    if (!item.IssueDate) {
      return { text: this.translate('not_received'), badgeClass: 'badge-warning' };
    }

    const isValid = !item.Duration || moment(item.ExpireDate).isAfter(moment());

    return isValid
      ? { text: this.translate('valid'), badgeClass: 'badge-success' }
      : { text: this.translate('expired'), badgeClass: 'badge-danger' };
  }

  colorBadgeStyle(item: any): Record<string, string> {
    return item.ColorCode ? { backgroundColor: item.ColorCode, color: '#fff' } : {};
  }

  /**
   * main.ts'teki formatDate / formatDateTimeLocal filtreleriyle ayni bicimi uretirler; bu
   * ekranda metot olarak duruyorlar cunku bos degeri '-' ile dolduruyorlar (filtreler undefined
   * donduruyor, tablo hucresi bos kaliyor) ve bir kismi TS tarafindan cagriliyor.
   *
   * DIKKAT: karsiliklari formatDate ve formatDateTime DEGIL formatDateTimeLocal'dir - global
   * formatDateTime filtresi moment.utc kullaniyor ve degeri kaydiriyor.
   */
  formatDate(value: string | Date): string {
    return value ? moment(value).format('DD.MM.YYYY') : '-';
  }

  formatDateTime(value: string | Date): string {
    return value ? moment(value).format('DD.MM.YYYY HH:mm') : '-';
  }
}
